module.exports = __webpack_public_path__ + "media/images/mastercard-9e1f0831b77c5a2707f4568c915d3f94.svg";